import React from 'react';
import PropTypes from 'prop-types';
import MainMenu from './MainMenu';
import AppMenu from './AppMenu';

const Header = props => (
    <div className={`page__header ${props.mod}`}>
        <section className="header page__header-wrapper">
            <a href="/olympic2018" className="header__logo"><span className="header__logo-image" /></a>

            <div className="header__nav">
                <MainMenu />
                <AppMenu />
            </div>
        </section>
    </div>
);

Header.propTypes = {
    mod: PropTypes.string.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx